import { BugReportRounded, CalculateRounded, CodeRounded, CompareArrowsRounded, DataArrayRounded, DataObjectRounded, ExposureRounded, FeedRounded, FilterAltRounded, ForkRightRounded, GroupRounded, InventoryRounded, JoinInnerRounded, LinearScaleRounded, MergeRounded, PivotTableChart, PlayCircleFilledRounded, RequestQuoteRounded, ShowChartRounded, StorageRounded, SuperscriptRounded, UnfoldMoreRounded } from '@mui/icons-material'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import { SxProps, Theme } from '@mui/material'
import { memo } from 'react'
import { NodeType } from '../../../definitions/Nodes'
import FlowUIManager from '../../../managers/FlowUIManager'

interface P {
    nodeType: NodeType
    size?: number
}

function NodesIcon({ nodeType, size }: P) {
    const mySize = size ?? 12
    const myColor = FlowUIManager.getNodeColor(nodeType)

    const icon = () => {
        const props: SxProps<Theme> = { fontSize: mySize, color: myColor }
        switch (nodeType) {
            case 'start': return <PlayCircleFilledRounded sx={props} />
            case 'ds_dynamo': return <DataObjectRounded sx={props} />
            case 'ds_redshift': return <StorageRounded sx={props} />
            case 'ds_contract': return <FeedRounded sx={props} />
            case 'xfrm_sql': return <JoinInnerRounded sx={props} />
            case 'xfrm_code': return <CodeRounded sx={props} />
            case 'xfrm_filterby': return <FilterAltRounded sx={props} />
            case 'xfrm_orderby': return <UnfoldMoreRounded sx={props} />
            case 'xfrm_groupby': return <GroupRounded sx={props} />
            case 'xfrm_reduce': return <CalculateRounded sx={props} />
            case 'xfrm_dataframeops': return <CalculateRounded sx={props} />
            case 'xfrm_merge': return <MergeRounded sx={props} />
            case 'xfrm_operations': return <ExposureRounded sx={props} />
            case 'xfrm_aggregateBy': return <GroupRounded sx={props} />
            case 'xfrm_pivot': return <PivotTableChart sx={props} />
            case 'xfrm_caseWhen': return <LinearScaleRounded sx={props} />
            case 'var_variable': return <DataArrayRounded sx={props} />
            case 'var_dataframe': return <ShowChartRounded sx={props} />
            case 'exe_subFlow': return <AccountTreeIcon sx={props} />
            case 'fork': return <ForkRightRounded sx={props} />
            case 'end_fork': return <CompareArrowsRounded sx={props} />
            case 'dummy': return <BugReportRounded sx={props} />
            case 'dummy2': return <BugReportRounded sx={props} />
            case 'out_csv': return <SuperscriptRounded sx={props} />
            case 'out_report': return <InventoryRounded sx={props} />
            case 'stmt_settlement': return <RequestQuoteRounded sx={props} />
        }
    }

    return (
        <>
            {icon()}
        </>
    )
}

export default memo(NodesIcon)
